import { render, staticRenderFns } from "./mobileSwiper.vue?vue&type=template&id=6357b1c8&scoped=true"
import script from "./mobileSwiper.vue?vue&type=script&lang=js"
export * from "./mobileSwiper.vue?vue&type=script&lang=js"
import style0 from "./mobileSwiper.vue?vue&type=style&index=0&id=6357b1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357b1c8",
  null
  
)

export default component.exports